const getSentryEnvByBrowserUrl = (): string => {
  const { hostname } = window.location;
  const matchResult = hostname.match(/^(.*)\..*\..*$/i);

  if (!matchResult || !matchResult[1]) {
    return 'unmapped';
  }
  return matchResult[1];
};

const config = {
  ENV: process.env.REACT_APP_ENV,
  COOKIES_DOMAIN: process.env.REACT_APP_COOKIES_DOMAIN,
  OKTA_DOMAIN: process.env.REACT_APP_OKTA_DOMAIN,
  OKTA_AUTH_SERVER_ID: process.env.REACT_APP_OKTA_AUTH_SERVER_ID,
  OKTA_CLIENT_ID: process.env.REACT_APP_OKTA_CLIENT_ID,
  LOGIN_URL: process.env.REACT_APP_LOGIN_URL,

  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  SENTRY_ENV: process.env.REACT_APP_DEVELOPMENT_MODE ? 'development' : getSentryEnvByBrowserUrl(),
  CUBE_JS_API_URL: process.env.REACT_APP_CUBE_JS_API_URL,
};

export default config;
